const register = {
  loginCredentials: "लॉग इन प्रमाण - पत्र", // translated 
  companyInformation: "कारखाना की जानकारी", // translated 
  contactDetails: "सम्पर्क करने का विवरण", // translated 
  businessName: "व्यवसाय का नाम", // translated 
  businessAddress: "व्यावसायिक पता", // translated 
  registrationCode: "पंजीकरण कोड", // translated 
  businessRegistrationNumber: "व्यवसाय पंजीकरण संख्या", // translated 
  websiteUrl: "वेबसाइट यूआरएल", // translated 
  mobilePhone: "चल दूरभाष", // translated 
  regionStateProvince: "क्षेत्र/राज्य/प्रांत", // translated 
  legalTitle: "कानूनी हक", // translated 
  city: "शहर", // translated 
  postalCode: "डाक कोड", // translated 
  registrationSuccess: "पंजीकरण सफलता।", // translated 
  pleaseWaitFewMomentsAndYouWillBeRedirectedToHome:
    "कृपया कुछ क्षण प्रतीक्षा करें, आपको होम पेज पर रीडायरेक्ट कर दिया जाएगा।", // translated 
  usernameEmail: "उपयोगकर्ता नाम (ईमेल)", // translated 
  password: "पासवर्ड", // translated 
  verifyPassword: "पासवर्ड को सत्यापित करें", // translated 
  documents: "दस्तावेज़", // translated 
  termsAndConditionsSection: "नियम एवं शर्तें", // translated 
  certificateOfIncorporation: "निगमन प्रमाणपत्र", // translated 
  acceptTermsAndConditions: "नियम और शर्तें स्वीकार करें", // translated 
  country: "देश", // translated 
  brandName: "ब्रांड का नाम", // translated 
  register: "पंजीकरण करवाना", // translated 
  isRequired: "आवश्यक है", // translated 
  passwordMin8Chars: "कम से कम 8 अक्षर होने चाहिए", // translated 
  passwordRequiresDigit: "इसमें कम से कम 1 अंक होना चाहिए", // translated 
  passwordRequiresLowercase: "इसमें कम से कम 1 छोटा अक्षर होना चाहिए", // translated 
  passwordRequiresUppercase: "इसमें कम से कम 1 बड़ा अक्षर होना चाहिए", // translated 
  passwordRequiresSpecialChar: 'इसमें कम से कम 1 विशेष वर्ण होना चाहिए (!@#$%^&*(),.?":{}|<>)', // translated 
  uploadFile: "फ़ाइल अपलोड करें", // translated 
  filename: "फ़ाइल नाम:", // translated 
  fileType: "प्रकार:", // translated 
  fileSize: "आकार:", // translated 
  maxFileSize10Mb: "अधिकतम: 10MB", // translated 
  supportedFileTypes: "समर्थित फ़ाइल प्रकार:", // translated 
  showPassword: "पासवर्ड दिखाए", // translated 
  hidePassword: "पासवर्ड छिपाएं", // translated 
  notAvailable: "लागू नहीं", // translated 
  fileSizeInKb: "{{size}} केबी", // translated 
  mobilePhonePlaceholder: "उदाहरण के लिए: +12025550123", // translated 
  websiteUrlPlaceholder: "http://www.example.com", // translated 
  loading: "लोड हो रहा है...", // translated 
  uploadingDocument: "दस्तावेज़ अपलोड हो रहा है...", // translated 
  percentUploaded: "{{प्रतिशत}}% अपलोड किया गया", // translated 
  registrationSuccessful: "सफल पंजीकरण।", // translated 
  failedToUploadDocument: "दस्तावेज़ अपलोड करने में विफल।", // translated 
  fieldIsRequired: "{{ये स्थान भरा जाना है}}", // translated 
  fieldMinLength: "{{field}} की लंबाई {{min}} अक्षरों से अधिक होनी चाहिए", // translated 
  fieldMustBeValidEmail: "{{field}} एक वैध ईमेल होना चाहिए", // translated 
  fieldPasswordMinLength: "{{field}} में कम से कम 8 अक्षर होने चाहिए", // translated 
  fieldPasswordRequiresDigit: "{{field}} में कम से कम 1 अंक होना चाहिए", // translated 
  fieldPasswordRequiresLowercase: "{{field}} में कम से कम 1 छोटा अक्षर होना चाहिए", // translated 
  fieldPasswordRequiresUppercase: "{{field}} में कम से कम 1 अपरकेस अक्षर होना चाहिए", // translated 
  fieldPasswordRequiresSpecialChar:
    '{{field}} में कम से कम 1 विशेष वर्ण होना चाहिए (!@#$%^&*(),.?":{}|<>)', // translated 
  passwordsDoNotMatch: "{{field}} {{otherField}} से मेल नहीं खाता", // translated 
  fieldBetweenLength: "{{field}} का मान {{min}} और {{max}} वर्णों के बीच होना चाहिए", // translated 
  postalCodeBetweenLength: "{{field}} कोड {{min}} और {{max}} अक्षरों के बीच होना चाहिए", // translated 
  invalidUrlFormat: "अमान्य यूआरएल प्रारूप", // translated 
  invalidEmailFormat: "ईमेल का प्रारूप अमान्य है", // translated 
  emailMustMatchUsername: "ईमेल और उपयोगकर्ता नाम (ईमेल) एक ही होने चाहिए।", // translated 
  mobilePhoneIsRequired: "मोबाइल फोन आवश्यक है", // translated 
  certificateFileTooLarge: "प्रमाणपत्र फ़ाइल का आकार बहुत बड़ा है", // translated 
  termsMustBeAccepted: "नियम और शर्तें स्वीकार करना अनिवार्य है।", // translated 
};


export default register;
